// The RESTORE location directory: every state hub with its cities, and every
// regional page. /locations/ renders all of it. State hubs link to the other
// state hubs and the regional pages from here (OtherLocations).

import type { ServiceAreaKey } from "@/lib/service-areas";

/** `serviceArea`: an out-of-market office (service-areas.ts); its card shows "Serving <city>". */
export type City = { name: string; address: string; to: string | null; serviceArea?: ServiceAreaKey };
export type State = { name: string; slug: string; cities: City[] };

export const STATES: State[] = [
  {
    name: "Arizona",
    slug: "arizona",
    cities: [
      { name: "Scottsdale", address: "7150 East Camelback Rd, Suite 444", to: "/locations/arizona/scottsdale/" , serviceArea: "scottsdale" },
    ],
  },
  {
    name: "California",
    slug: "california",
    cities: [
      { name: "Beverly Hills", address: "8383 Wilshire Blvd, Suite 800", to: "/locations/california/beverly-hills/" , serviceArea: "beverly-hills" },
      { name: "Newport Beach", address: "895 Dove Street, 3rd Floor", to: "/locations/california/newport-beach/" , serviceArea: "newport-beach" },
      { name: "San Diego", address: "350 10th Ave, Suite 1000", to: "/locations/california/san-diego/" , serviceArea: "san-diego" },
      { name: "San Francisco", address: "75 Broadway, Suite 202", to: "/locations/california/san-francisco/" , serviceArea: "san-francisco" },
    ],
  },
  {
    name: "Colorado",
    slug: "colorado",
    cities: [
      { name: "Boulder", address: "4770 Baseline Rd, Office 232", to: "/locations/colorado/boulder/" },
      { name: "Colorado Springs", address: "102 S. Tejon Street, Suite 1100", to: "/locations/colorado/colorado-springs/" , serviceArea: "colorado-springs" },
      { name: "Downtown Denver", address: "2301 Blake St, Suite 113", to: "/locations/restore-denver/" },
      { name: "Greenwood Village", address: "5445 DTC Pkwy, Suite 1015", to: "/locations/restore-denver/" },
    ],
  },
  {
    name: "District of Columbia",
    slug: "district-of-columbia",
    cities: [
      { name: "Washington DC", address: "1875 I Street, NW, 5th Floor", to: "/locations/district-of-columbia/" , serviceArea: "washington-dc" },
    ],
  },
  {
    name: "Florida",
    slug: "florida",
    cities: [
      { name: "Boca Raton", address: "2255 Glades Road, Suite 324A", to: "/locations/florida/boca-raton/" , serviceArea: "boca-raton" },
      { name: "Jacksonville", address: "4651 Salisbury Rd, Suite 400", to: "/locations/florida/jacksonville/" , serviceArea: "jacksonville" },
      { name: "Miami", address: "80 SW 8th St, Suite 2000", to: "/locations/florida/miami/" , serviceArea: "miami" },
      { name: "Tampa", address: "8875 Hidden River Pkwy, Suite 300", to: "/locations/florida/tampa/" , serviceArea: "tampa" },
    ],
  },
  {
    name: "Georgia",
    slug: "georgia",
    cities: [
      { name: "Atlanta", address: "1201 Peachtree Street, Suite 200", to: "/locations/georgia/atlanta/" , serviceArea: "atlanta" },
    ],
  },
  {
    name: "Illinois",
    slug: "illinois",
    cities: [
      { name: "Chicago \u2013 Fulton Market", address: "159 N Sangamon St, Suite 200", to: "/locations/restore-chicago/" },
      { name: "Chicago \u2013 Hancock Center", address: "875 North Michigan Avenue, 31st Floor", to: "/locations/restore-chicago/" },
      { name: "Chicago Lincoln Park", address: "939 W. North Avenue, Suite 750", to: "/locations/restore-chicago/" },
      { name: "Deerfield", address: "500 Lake Cook Road, Suite #350", to: "/locations/restore-chicago/" },
      { name: "Lake Forest", address: "100 S. Saunders Rd, Suite 150", to: "/locations/restore-chicago/" },
      { name: "Oak Brook", address: "1415 22nd St, #950", to: "/locations/restore-chicago/" },
      { name: "Orland Park", address: "15255 S 94th Ave, 5th floor", to: "/locations/restore-chicago/" },
      { name: "Schaumburg", address: "10 N. Martingale Rd, Suite 400", to: "/locations/restore-chicago/" },
      { name: "St. Charles", address: "100 Illinois St, Suite 200", to: "/locations/restore-chicago/" },
    ],
  },
  {
    name: "Indiana",
    slug: "indiana",
    cities: [
      { name: "Indianapolis", address: "450 E. 96th St, Suite 500", to: "/locations/indiana/indianapolis/" , serviceArea: "indianapolis" },
    ],
  },
  {
    name: "Louisiana",
    slug: "louisiana",
    cities: [
      { name: "New Orleans", address: "1615 Poydras St, Suite 900", to: "/locations/louisiana/new-orleans/" , serviceArea: "new-orleans" },
    ],
  },
  {
    name: "Maryland",
    slug: "maryland",
    cities: [
      { name: "Baltimore", address: "4000 East Pratt St, 8th Floor", to: "/locations/maryland/baltimore/" , serviceArea: "baltimore" },
    ],
  },
  {
    name: "Massachusetts",
    slug: "massachusetts",
    cities: [
      { name: "Boston", address: "75 Arlington Street, Suite 500", to: "/locations/massachusetts/boston/" , serviceArea: "boston" },
    ],
  },
  {
    name: "Michigan",
    slug: "michigan",
    cities: [
      { name: "Novi", address: "39555 Orchard Hill Place, Suite 600", to: "/locations/michigan/novi/" , serviceArea: "novi" },
    ],
  },
  {
    name: "Minnesota",
    slug: "minnesota",
    cities: [
      { name: "Edina", address: "5201 Eden Ave, Suite 300", to: "/locations/minnesota/edina/" , serviceArea: "edina" },
    ],
  },
  {
    name: "Missouri",
    slug: "missouri",
    cities: [
      { name: "Kansas City", address: "2300 Main Street, Suite 900", to: "/locations/missouri/kansas-city/" , serviceArea: "kansas-city" },
      { name: "St. Louis", address: "2 Cityplace Dr, 2nd Floor", to: "/locations/missouri/st-louis/" , serviceArea: "st-louis" },
    ],
  },
  {
    name: "Nevada",
    slug: "nevada",
    cities: [
      { name: "Henderson", address: "871 Coronado Center Drive, Suite 200", to: "/locations/nevada/las-vegas/" , serviceArea: "las-vegas" },
    ],
  },
  {
    name: "New Jersey",
    slug: "new-jersey",
    cities: [
      { name: "Neptune", address: "3600 Route 66", to: "/locations/new-jersey/neptune/" , serviceArea: "neptune" },
      { name: "Newark", address: "One Gateway Center", to: "/locations/new-jersey/newark/" , serviceArea: "newark" },
      { name: "Paramus", address: "140 E Ridgewood Avenue", to: "/locations/new-jersey/paramus/" , serviceArea: "paramus" },
    ],
  },
  {
    name: "New York",
    slug: "new-york",
    cities: [
      { name: "Brooklyn Heights", address: "300 Cadman Plaza W", to: "/locations/new-york/brooklyn-heights/" },
      { name: "Manhasset", address: "1129 Northern Blvd", to: "/locations/restore-northeast/" },
      // /locations/nyc/ is the WordPress NYC page, rebuilt 6 Oct 2026. It lists the Manhattan clinic.
      { name: "Manhattan", address: "240 W 37th St, 5th Floor", to: "/locations/nyc/" },
      { name: "Melville", address: "555 Broadhollow Rd", to: "/locations/restore-northeast/" },
      { name: "Nassau County", address: "1979 Marcus Ave, Suite 210, Lake Success", to: "/locations/new-york/nassau-county/" },
      { name: "Queens", address: "118-35 Queens Blvd, Forest Hills Tower", to: "/locations/new-york/queens/" },
      { name: "White Plains", address: "50 Main Street, White Plains", to: "/locations/new-york/white-plains/" },
    ],
  },
  {
    name: "North Carolina",
    slug: "north-carolina",
    cities: [
      { name: "Charlotte", address: "7725 Ballantyne Commons Parkway, Suite 101", to: "/locations/restore-charlotte/" },
      { name: "Cornelius", address: "19109 West Catawba Ave, Suite 200", to: "/locations/restore-charlotte/" },
      { name: "Raleigh", address: "4509 Creedmoor Rd, Suite 201", to: "/locations/north-carolina/raleigh/" , serviceArea: "raleigh" },
    ],
  },
  {
    name: "Ohio",
    slug: "ohio",
    cities: [
      { name: "Cincinnati", address: "300 E. Business Way, Suite 200", to: "/locations/ohio/cincinnati/" , serviceArea: "cincinnati" },
      { name: "Columbus", address: "100 E. Campus View Boulevard, Suite 250", to: "/locations/ohio/columbus/" , serviceArea: "columbus" },
      { name: "Independence", address: "6100 Oak Tree Boulevard, Suite 200", to: "/locations/ohio/independence/" , serviceArea: "independence" },
    ],
  },
  {
    name: "Oklahoma",
    slug: "oklahoma",
    cities: [
      { name: "Oklahoma City", address: "101 Park Ave, Suite 1300", to: "/locations/oklahoma/oklahoma-city/" , serviceArea: "oklahoma-city" },
    ],
  },
  {
    name: "Oregon",
    slug: "oregon",
    cities: [
      { name: "Portland", address: "205 SE Spokane St, Suite 300", to: "/locations/oregon/portland/" , serviceArea: "portland" },
    ],
  },
  {
    name: "Pennsylvania",
    slug: "pennsylvania",
    cities: [
      { name: "Philadelphia", address: "325-41 Chestnut Street, Suite 800", to: "/locations/pennsylvania/philadelphia/" , serviceArea: "philadelphia" },
      { name: "Pittsburgh", address: "322 North Shore Drive, Building 1B, Suite 200", to: "/locations/pennsylvania/pittsburgh/" , serviceArea: "pittsburgh" },
    ],
  },
  {
    name: "Tennessee",
    slug: "tennessee",
    cities: [
      { name: "Nashville", address: "3200 West End Ave, Suite 500", to: "/locations/tennessee/nashville/" , serviceArea: "nashville" },
    ],
  },
  {
    name: "Texas",
    slug: "texas",
    cities: [
      { name: "Allen", address: "825 Watters Creek Blvd, Building M Suite 250", to: "/locations/texas/allen/" },
      { name: "Arlington", address: "3901 Arlington Highlands Blvd, Suite 200", to: "/locations/restore-dallas/" },
      { name: "Austin", address: "300 Beardsley Lane, Bldg C, Suite 101", to: "/locations/texas/austin/" , serviceArea: "austin" },
      { name: "Dallas \u2013 Highland Park", address: "4514 Cole Avenue, Office #605", to: "/locations/texas/dallas-highland-park/" },
      { name: "Dallas \u2013 Plano", address: "5425 W Spring Creek, Suite 170", to: "/locations/restore-dallas/" },
      { name: "Fort Worth", address: "1751 River Run, Suite 200", to: "/locations/texas/fort-worth/" },
      { name: "Houston", address: "2929 Allen Pkwy, Suite 200", to: "/locations/texas/houston/" , serviceArea: "houston" },
      { name: "San Antonio", address: "700 N St Mary's St, Suite 1400", to: "/locations/texas/san-antonio/" , serviceArea: "san-antonio" },
      { name: "South Lake", address: "950 E State Hwy 114", to: "/locations/texas/south-lake/" },
    ],
  },
  {
    name: "Utah",
    slug: "utah",
    cities: [
      { name: "Salt Lake City", address: "222 S Main St, 5th Floor", to: "/locations/utah/salt-lake-city/" , serviceArea: "salt-lake-city" },
    ],
  },
  {
    name: "Virginia",
    slug: "virginia",
    cities: [
      { name: "Virginia Beach", address: "780 Lynnhaven Pkwy, Suite 400", to: "/locations/virginia/virginia-beach/" , serviceArea: "virginia-beach" },
    ],
  },
  {
    name: "Wisconsin",
    slug: "wisconsin",
    cities: [
      { name: "Milwaukee", address: "250 East Wisconsin Avenue, Suite 1800", to: "/locations/wisconsin/milwaukee/" , serviceArea: "milwaukee" },
    ],
  },
];

export const REGIONS = [
  { label: "Charlotte", href: "/locations/restore-charlotte/" },
  { label: "Chicago", href: "/locations/restore-chicago/" },
  { label: "Dallas", href: "/locations/restore-dallas/" },
  { label: "Denver", href: "/locations/restore-denver/" },
  { label: "Northeast", href: "/locations/restore-northeast/" },
  { label: "Midwest", href: "/locations/restore-midwest/" },
  { label: "South", href: "/locations/restore-south/" },
  { label: "West", href: "/locations/restore-west/" },
];

